import { axiosInstance as axios } from 'helpers/axiosInstance';
import logger from 'utilities/logger';

export const getWaitTime = async (phoneNumber: string): Promise<Models.PhoneWaitTime> => {
	try {
		const phoneResponse = await axios({
			url: `/engagement-api/v1/dap/phone/RetriveWaitTime?phoneNumber=${phoneNumber}`,
			method: 'GET',
		});
		const phoneWaitTime: Models.PhoneWaitTime = phoneResponse?.data;
		if (!phoneWaitTime) logger.error(phoneResponse.data.message);
		return phoneWaitTime;
	} catch (error) {
		const message = error?.response?.data?.message ?? error;
		logger.error(`Phone data retrieval failed: ${message}`);
		throw message;
	}
};
